'use-client';

import { useDynamicContext } from '@dynamic-labs/sdk-react-core';
import { usePathname } from 'next/navigation';

import { tw } from '@repo/ui';

import { DoodHeader } from './dood-header';
import { Navigation } from './navigation';

export const Header: React.FC = () => {
  const { user } = useDynamicContext();
  const pathname = usePathname();

  if (!user) {
    return null;
  }

  return (
    <header
      className={tw('relative w-full gap-4', 'flex flex-col items-center')}
    >
      <Navigation />
      {pathname === '/' ? <DoodHeader /> : null}
    </header>
  );
};
